import React, {useState, useEffect} from 'react';
import {Form, Button, Alert} from 'react-bootstrap';
import {Formik} from 'formik';
//import {Helmet} from "react-helmet";
import {useNavigate, useParams} from 'react-router-dom';

import axios from 'axios';
import {apiUrl} from '../../util/Api';

//import {string, object} from 'yup';
import * as Yup from 'yup';



const validationSchema = Yup.object({
  app: Yup.string().required('a name is required.'),
  //typeId: Yup.string().required('a type is required.'),
});

const AppForm = () => {
  const [errors, setErrors] = useState([]);
  //const [appTypes, setAppTypes] = useState([]);
  //const [appTypes, setAppTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  //const [genaiModels, setGenaiModels] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [defaultAccountKey, setDefaultAccountKey] = useState('');

  let {accountKey} = useParams();

  let navigate = useNavigate();

  useEffect(() => {
    document.title = `reconify add app`;
    /*
    axios.get(apiUrl + '/app-types', {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        setAppTypes(res.data.appTypes);
      }
    })
    .catch((err) => {

    });
    */
    axios.get(apiUrl + '/categories', {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        setCategories(res.data.categories);
      }
    })
    .catch((err) => {

    });

    /*
    axios.get(apiUrl + '/genai-models', {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        setGenaiModels(res.data.models);
      }
    })
    .catch((err) => {

    });
    */
    //accounts belonging to user
    //if account passed in, use that
    if(!accountKey) {
      axios.post(apiUrl + '/accounts/useraccounts',
        {
          minRoleId: 2
        }, {withCredentials: true})
      .then((res) => {
        if(res.data.status === 'ok') {
          //if(res.data.accounts > 1) {
          if(Array.isArray(res.data.accounts) && res.data.accounts.length > 1) {
          //if(res.data.accounts.length > 1) {
            //console.log('accounts:', res.data.accounts)
            setAccounts(res.data.accounts);
          }
          else {
            //console.log('account:', res.data.accounts[0])
            setDefaultAccountKey(res.data.accounts[0].accountKey)
          }
        }
      })
      .catch((err) => {

      });
    } else {
      setDefaultAccountKey(accountKey)
    }


  },[accountKey]);

  const submitSubmit = (values, actions) => {
    //console.log("submitting app form", values);
    setErrors([]);

    if(values.accountKey === '') {
      values.accountKey = defaultAccountKey;
    }

    //console.log('updated values:', values);

    let isAuthError = false;

    axios.post(apiUrl + '/apps/add', values, {withCredentials: true})
    .then((res) => {
      //console.log('logged in');
      //console.log("add results:", res.data);
      if(res.data.status === "ok" && res.data.app && res.data.app.appKey) {
        //redirect
        navigate(`/account/${accountKey}/apps/detail/${res.data.app.appKey}`);
      }
      else {
        //console.log('an error was returned');
        //display errors
        let errorMsgs = [];
        //reset TOS link?
        //values.tosAgree = [];
        let redirectToLogin = false;
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'auth-expired':
            case 'auth-error':
            case 'no-auth':
            case 'no-valid-account':
              //console.log('auth expired');
              isAuthError = true;
              //errorMsgs.push('You have been logged out.');
              //return;
              redirectToLogin = true;
              break;
            case 'no-permissions':
              errorMsgs.push('Your do not have permissions to create an app.');
              break;
            case 'name-missing':
              errorMsgs.push('Please enter a name for the app.');
              break;
            default:
              errorMsgs.push('There was an error adding the app.');
          }
        });
        if(redirectToLogin) {
          navigate('/login');
          return;
        }
        //don't call setErrors if not logged in as it throws an unmounted error
        if(!isAuthError) {
          setErrors(errorMsgs);
        }
        //setErrors(errorMsgs);
      }
    })
    .catch((err) => {
      //console.error(err);
      //console.log('something went wrong');
      setErrors(['An error occurred while adding the app.']);
    });

  }

  //<Form.Control type="hidden" value={defaultAccountKey} name="accountKey"/>

  //check if logged in
  return (
    <div>
      
      <h3>Add an App</h3>
      <p>
        Use the form below to add an application you want to track.
      </p>
      {
        errors.length > 0 ? (
          <Alert variant='danger'>
          {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }

    <Formik validationSchema={validationSchema}
      onSubmit={submitSubmit}
      initialValues={{app:'',accountKey:'', 
        //typeId:'', genaiModelId: 0, categoryId:0,  
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors
      }) => (
        <Form noValidate onSubmit={handleSubmit} className='col-md-7 col-sm-8'>
          <Form.Group controlId='app-name' className='mb-3'>
            <Form.Label>App Name <span className='required-field'>*</span></Form.Label>
            <Form.Control type="text" placeholder="name of app"
              name="app" value={values.app} onChange={handleChange}
              isInvalid={touched.app && errors.app}
            />
            <Form.Control.Feedback type="invalid">{errors.app}</Form.Control.Feedback>
          </Form.Group>
          {
            accounts.length > 1 ? (
              <Form.Group controlId='app-account' className='mb-3'>
                <Form.Label>Account</Form.Label>
                <Form.Control as="select" name="accountKey" onChange={handleChange}>
                  {accounts.map((account, i) => (<option key={'account.' + i} value={account.accountKey}>{account.account}</option>))}
                </Form.Control>
              </Form.Group>
            ) : (
              null
            )
          }
          {/* 
          <Form.Group controlId='app-type' className='mb-3'>
            <Form.Label>Type <span className='required-field'>*</span></Form.Label>
            <Form.Control as="select" name="typeId" onChange={handleChange} isInvalid={touched.typeId && errors.typeId}>
              <option value="">Select one</option>
              {
                appTypes.length > 0 ? (
                  <>
                  {appTypes.map((appType, i) => (<option key={'appType.' + i} value={appType.appTypeId}>{appType.appType}</option>))}
                  </>
                ) : (null)
              }
            </Form.Control>
            <Form.Control.Feedback type="invalid">{errors.typeId}</Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId='app-model' className='mb-3'>
            <Form.Label>Model</Form.Label>
            <Form.Control as="select" name="genaiModelId" onChange={handleChange}>
              <option value="0">Select one</option>
              {
                appTypes.length > 0 ? (
                  <>
                  {genaiModels.map((model, i) => (<option key={'model.' + i} value={model.id}>{model.model}</option>))}
                  </>
                ) : (null)
              }
            </Form.Control>
          </Form.Group>
          */}
          <Form.Group controlId='app-category' className='mb-3'>
            <Form.Label>Category</Form.Label>
            <Form.Control as="select" name="categoryId" onChange={handleChange}>
              <option value="0">Select one</option>
              {
                categories.length > 0 ? (
                  <>
                  {categories.map((category, i) => (<option key={'category.' + i} value={category.id}>{category.category}</option>))}
                  </>
                ) : (null)
              }
            </Form.Control>
          </Form.Group>
          <Button variant="primary" type="submit">Add App</Button>
        </Form>
      )}
    </Formik>
    </div>
  );
}

//(values, {setSubmitting, resetForm}) => { }



//this caused immediate validation: isInvalid={!!errors.email}
//const LoginForm = () => {
//}

export default AppForm;
